import ChartBar from "./ChartBar";
import ChartPie from "./ChartPie";

export {
    ChartBar,
    ChartPie
};
